export default "__VITE_ASSET__a194c1f4__"